export enum PostLogoutWorkflow {
  Default = 'default',
  OpenIdConnect = 'open-id-connect',
}
